import React from 'react'
import SideNav from './SideNav'

const LivingRoomDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-living-room-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Living Room Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/living-room-designs-mehome.jpg" alt="Living Room Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      The living room sets the tone for your entire home. 
                      At <b>MeHome</b>, we design spaces that are equal parts elegant and inviting — where comfort meets artistry. 
                      Every design element, from layout to lighting, is planned to enhance flow, ambiance, and visual harmony.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Crafted for <span>Comfort, Function & Style</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Our team blends design intuition with technical precision to create living areas that feel open, warm, and timeless. 
                      Each room is designed to adapt seamlessly to your lifestyle while standing out as a masterpiece of design.
                    </p>

                    <ul>
                      <li>Customized layouts to maximize space and natural light.</li>
                      <li>Accent walls and statement furniture for bold visual appeal.</li>
                      <li>Color palettes that define your mood and personality.</li>
                      <li>Lighting designs that create ambiance and comfort.</li>
                      <li>Integration of technology and smart living concepts.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Signature <span> Living Room Styles</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🛋️</div>
                        <div className="why-choose-item-content">
                          <h3>Modern Minimalist</h3>
                          <p>
                            Simple forms, neutral tones, and open layouts create a calm, clutter-free environment ideal for today’s urban lifestyle.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🏡</div>
                        <div className="why-choose-item-content">
                          <h3>Luxury Classic</h3>
                          <p>
                            Elegant molding, rich fabrics, and layered textures that express timeless grandeur and sophistication.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🌿</div>
                        <div className="why-choose-item-content">
                          <h3>Nature-Inspired</h3>
                          <p>
                            Earthy tones, organic materials, and soft lighting bring serenity and a sense of balance to your living space.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Contemporary Fusion</h3>
                          <p>
                            A blend of modern and cultural influences — creating vibrant yet sophisticated living spaces full of character.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">🎨</div>
                        <div className="why-choose-item-content">
                          <h3>Art & Decor Curation</h3>
                          <p>
                            Personalized artwork, rugs, and décor pieces that add personality, depth, and cultural charm to the interiors.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-gallery wow fadeInUp" data-wow-delay="0.6s">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Featured <span> Living Room Projects</span>
                      </h2>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/living1.jpg" alt="Living Project 1" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/living2.jpg" alt="Living Project 2" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/living3.jpg" alt="Living Project 3" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Choose <span> MeHome for Living Spaces</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>Vision to Reality:</b> Translating design concepts into tangible, livable art.</li>
                        <li><b>Expert Craftsmanship:</b> Every element built with precision and quality assurance.</li>
                        <li><b>Space Intelligence:</b> Functional layouts for every square foot of your home.</li>
                        <li><b>Design Personality:</b> Each living room customized to reflect its owner’s spirit.</li>
                        <li><b>Seamless Execution:</b> Professional handling from design to decor finishing.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default LivingRoomDesigns
